import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {I18nModule} from '@spartacus/core';
import {DefaultConfiguratorErrorComponent} from './default-configurator-error.component';
import {GenericConfiguratorErrorModule} from '../generic-configurator-error/generic-configurator-error.module';
import {NetNewModule} from '../net-new/net-new.module';
import {ContactUsLinkModule} from '@dcp/configurator';

@NgModule({
  declarations: [DefaultConfiguratorErrorComponent],
  exports: [
    DefaultConfiguratorErrorComponent
  ],
  imports: [
    CommonModule,
    I18nModule,
    GenericConfiguratorErrorModule,
    NetNewModule,
    ContactUsLinkModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class DefaultConfiguratorErrorModule {
}
